import React, { useState } from 'react'

import Field from '../../Field/Field'
import TextInput from '../../TextInput/TextInput'
import Tooltip from '../../Tooltip/Tooltip'
import FieldLabel from '../../FieldLabel/FieldLabel'
import Checkbox from '../../Checkbox/Checkbox'
import Radio from '../../Radio'
import Help from '../../Help/Help'
import ToggleSwitch from '../../ToggleSwitch/ToggleSwitch'
import { getContentTypeFieldDataTestId, CONTENT_TYPE_FIELD_ACTION_IDS } from '../helper'
import { booleanTestIdFormatter } from './../../../utils/helpers'
import Textarea from '../../Textarea/Textarea'
import UrlPatternTextDropdown from './UrlV2/UrlPatternTextDropdown'
import UrlFormattingOptions from './UrlV2/UrlFormattingOptions'

const Url = (props: any) => {
  const {
    onChange,
    uniqueKey,
    schema,
    options,
    setOptions,
    type,
    isNonLocalizable,
    hasNonLocalizablePlan,
    urlManagementV2Visible,
    contentTypeSchemaTree,
    t
  } = props
  const [initialSchema, setSchema] = useState(schema)
  const [initialOptions, setCTOptions] = useState(options)

  const [enabledSwitch, setEnabledSwitch] = useState(options?.url_pattern !== false && options?.url_pattern !== '/');


  const onchange = () => {
    onChange && onChange()
    setSchema({ ...schema })
    // setCTOptions({ ...options })
  }

  const onPlaceholderChange = (event: any) => {
    schema.field_metadata.placeholder = event.target.value
    onchange()
  }

  const onInstructionChange = (event: any) => {
    schema.field_metadata.instruction = event.target.value
    onchange()
  }

  const onHelpTextChange = (event: any) => {
    schema.field_metadata.description = event.target.value
    onchange()
  }

  const onUrlPrefixChange = (event: any) => {
    options.url_prefix = event.target.value
    setCTOptions({ ...options })
    setOptions(options)
    onchange()
  }
  const onUrlPatternChange = (event: any) => {
    options.url_pattern = event.target.value !== 'false' ? event.target.value : false
    if (event.target.value === 'false') {
      options.url_prefix = '/'
    }
    setCTOptions({ ...options })
    setOptions(options)
    onchange()
  }
  const onOptionsChange = (event: any) => {
    if (event.target.name === `${uniqueKey}.nonLocalization`) {
      schema.non_localizable = event.target.checked
    } else if (event.target.name === `${uniqueKey}.mandatory`) {
      schema.mandatory = event.target.checked
    }
    onchange()
  }
  const onCustomUrlChange = (event: any) => {
    options.url_pattern = event.target.value
    setCTOptions({ ...options })
    setOptions(options)
    onchange()
  }

   const onValChnage = (event: any) => {
    schema.format = event.target.value
    onchange()
  }

  const onValErrChange = (event: any) => {
    if (schema.error_messages) {
      schema.error_messages.format = event.target.value
    } else {
      schema.error_messages = {
        format: event.target.value
      }
    }
    onchange()
  }

  const onToggleSwitch = (event: any) => {
    setEnabledSwitch(event.target.checked)
    if (event.target.checked) {
      options.url_pattern = initialOptions.url_pattern || '/:title'
      options.url_prefix = initialOptions.url_prefix || ''
    } else {
      options.url_pattern = false
      options.url_prefix = '/'
      delete schema?.formatting_options
    }
    setCTOptions({ ...options })
    setOptions(options)
    onchange()
  }

  let customUrl =
    options.url_pattern !== '/:title' &&
    options.url_pattern !== '/:year/:month/:day/:title' &&
    options.url_pattern !== '/:year/:month/:title' &&
    options.url_pattern !== false

  let disable = options.url_pattern === false && options.url_prefix === '/'

  if (type === 'basic') {
    return (
      <div>
        <div className="FormFields">
          {!options?.singleton &&
            <>
              <FieldLabel version="v2" testId="cs-form-field-url-enable-pattern-label" htmlFor="urlPrefix">{t('ContentTypeFieldProperties.Url.url_preset') || 'URL Preset'}</FieldLabel>
              <div>
                <ToggleSwitch
                  testId={"cs-ct-field-url-enable"}
                  name={`${uniqueKey}.url`}
                  label={t('ContentTypeFieldProperties.Url.preset_enabled') || 'Preset Enabled'}
                  checked={enabledSwitch}
                  onChange={onToggleSwitch}
                />
              </div>
              {urlManagementV2Visible ? (
                <>
                  <Field className="mt-20">
                    <FieldLabel version="v2" testId="cs-form-field-url-prefix" htmlFor="urlPrefix">
                      {t('ContentTypeFieldProperties.Url.prefix') || 'Prefix'}
                    </FieldLabel>
                    <Help
                      testId="cs-form-field-url-pattern-help-text"
                      type="basic"
                      text={t('ContentTypeFieldProperties.Url.url_prefix_help') || 'Use a pattern to auto-generate URLs and optionally prepend a static prefix such as /blog.'}
                    />
                    <TextInput
                      name={`${uniqueKey}.urlPrefix`}
                      version="v2"
                      placeholder={t('ContentTypeFieldProperties.Url.url_prefix_placeholder') || 'URL prefix (optional)'}
                      disabled={options.url_prefix === '/' && options.url_pattern === false}
                      value={options.url_prefix ? (options.url_prefix !== '/' ? options.url_prefix : '') : ''}
                      onChange={onUrlPrefixChange}
                      autoFocus
                      testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.DISPLAY_NAME_INPUT)}
                    />
                  </Field>
                  <Field className="mt-20">
                    <UrlPatternTextDropdown
                      uniqueKey={uniqueKey}
                      schema={schema}
                      options={options}
                      setOptions={setOptions}
                      onNotifyChange={onchange}
                      disabled={!enabledSwitch}
                      contentTypeSchemaTree={contentTypeSchemaTree}
                    />
                  </Field>
                </>
              ) : (
                <>
              <Field className="pl-32 mt-20">
                <FieldLabel version="v2" testId="cs-form-field-url-prefix" htmlFor="urlPrefix">{t('ContentTypeFieldProperties.Url.prefix') || 'Prefix'}</FieldLabel>
                <Help testId="cs-form-field-url-pattern-help-text" type="basic"
                  text={t('ContentTypeFieldProperties.Url.url_prefix_help') || 'Use a pattern to auto-generate URLs and optionally prepend a static prefix such as /blog.'}
                />
                <TextInput
                  name={`${uniqueKey}.urlPrefix`}
                  version="v2"
                  placeholder={t('ContentTypeFieldProperties.Url.url_prefix_placeholder') || 'URL prefix (optional)'}
                  disabled={options.url_prefix === '/' && options.url_pattern === false}
                  value={options.url_prefix ? (options.url_prefix !== '/' ? options.url_prefix : '') : ''}
                  onChange={onUrlPrefixChange}
                  autoFocus
                  testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.DISPLAY_NAME_INPUT)}
                />
              </Field>
              <Field className="pl-32">
                <FieldLabel version="v2" testId="cs-form-field-url-pattern" htmlFor="urlPrefix">{t('ContentTypeFieldProperties.Url.pattern') || 'Pattern'}</FieldLabel>
                <div className="FormFields__selection-wrapper mt-8">
                  <Radio
                    testId="cs-ct-field-url-title"
                    radioDisplayType="block"
                    name={`${uniqueKey}.url`}
                    value="/:title"
                    text={t('ContentTypeFieldProperties.Url.url_pattern_title') || 'Title'}
                    checked={options.url_pattern === '/:title'}
                    onChange={onUrlPatternChange}
                    disabled={disable}
                  />
                  <Radio
                    testId="cs-ct-field-url-date-title"
                    radioDisplayType="block"
                    name={`${uniqueKey}.url`}
                    value="/:year/:month/:day/:title"
                    text={t('ContentTypeFieldProperties.Url.url_pattern_date_title') || 'Date and Title'}
                    checked={options.url_pattern === '/:year/:month/:day/:title'}
                    onChange={onUrlPatternChange}
                    disabled={disable}
                  />
                  <Radio
                    testId="cs-ct-field-url-month-title"
                    radioDisplayType="block"
                    name={`${uniqueKey}.url`}
                    value="/:year/:month/:title"
                    text={t('ContentTypeFieldProperties.Url.url_pattern_month_title') || 'Month and Title'}
                    checked={options.url_pattern === '/:year/:month/:title'}
                    onChange={onUrlPatternChange}
                    disabled={disable}
                  />
                  <div className="FormFields__with-help">
                    <Radio
                      testId="cs-ct-field-url-custom"
                      radioDisplayType="block"
                      name={`${uniqueKey}.url`}
                      text={t('ContentTypeFieldProperties.Url.url_pattern_custom') || 'Custom'}
                      value=""
                      checked={customUrl}
                      onChange={onUrlPatternChange}
                      disabled={disable}
                    />
                    <div className="FormFields__help-tooltip">
                      <Help
                        alignment="left"
                        testId="cs-form-field-url-custom-help-text"
                        type="basic"
                        tippyProps={{
                          interactive: false
                        }}
                        text={
                          <>
                            <div className="mb-20">
                              Select this to set a custom pattern for the URLs by using the following available variables or
                              custom text, or a combination of both.
                            </div>
                            <div>
                              <span className="font-bold">:title</span> – Displays the title of the entry
                            </div>
                            <div>
                              <span className="font-bold">:unique_id</span> – Displays the unique ID of the entry
                            </div>
                            <div>
                              <span className="font-bold">:year</span> – Displays the year of creation
                            </div>
                            <div>
                              <span className="font-bold">:year_short</span> – Displays the short version of the year of
                              creation
                            </div>
                            <div>
                              <span className="font-bold">:month</span> – Displays the month(numeric) of creation
                            </div>
                            <div>
                              <span className="font-bold">:monthname</span> – Displays the name of the month (e.g. january)
                              of creation
                            </div>
                            <div>
                              <span className="font-bold">:monthname_short</span> – Displays the name of the month (in
                              short, e.g., jan)
                            </div>
                            <div>
                              <span className="font-bold">:day</span> – Displays the day (numeric, e.g., 30) of creation
                            </div>
                            <div>
                              <span className="font-bold">:year-:month-:day</span> – Displays the year/month/date of
                              creation
                            </div>
                            <div className="mt-20">
                              Example – If you use <span className="font-bold">':year-:month-:day'</span> in the custom
                              field, your URL will look like this :{' '}
                              <span className="font-bold">www.example.com/2016-04-30</span>"
                            </div>
                          </>
                        }
                      />
                    </div>
                  </div>
                  <div className="FormFields__with-help-input">
                    <FieldLabel version="v2" testId="cs-form-field-url-custom-url" htmlFor="urlPrefix">{t('ContentTypeFieldProperties.Url.enter_custom_url_pattern') || 'Enter Custom URL Pattern'}</FieldLabel>
                    <TextInput
                      name={`${uniqueKey}.customUrl`}
                      version="v2"
                      width="full"
                      disabled={!customUrl || disable}
                      className="mt-8"
                      value={
                        customUrl
                          ? options.url_pattern
                            ? options.url_pattern === 'false'
                              ? ''
                              : options.url_pattern || ''
                            : ''
                          : ''
                      }
                      placeholder={t('ContentTypeFieldProperties.Url.enter_custom_url_placeholder') || 'Enter custom URL'}
                      onChange={onCustomUrlChange}
                      testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.CUSTOM_URL_INPUT)}
                    />
                  </div>
                  {/* <Radio
                testId="cs-ct-field-url-disable"
                name={`${uniqueKey}.url`}
                text="Disable"
                value="false"
                checked={options.url_pattern === false || options.url_pattern === 'false'}
                onChange={onUrlPatternChange}
              /> */}
                </div>
              </Field>
                </>
              )}
            </>
          }
          <Field>

            <FieldLabel testId="cs-form-field-title-placeholder" version="v2" htmlFor="placeholder">{t('ContentTypeFieldProperties.Url.placeholder_value') || 'Placeholder Value'}</FieldLabel>
            <TextInput
              version="v2"
              name={`${uniqueKey}.placeholder`}
              value={schema.field_metadata.placeholder || ''}
              onChange={onPlaceholderChange}
              placeholder={props.t('content_type.save_content_type.body.fields.common_properties.placeholders.enter_value')}
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.PLACEHOLDER_INPUT)}
            />
          </Field>
          <Field>
            <FieldLabel testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.INSTRUCTION_INPUT)}-label`} className='FieldLabel__CT' htmlFor="instruction" version="v2">{t('ContentTypeFieldProperties.Url.instruction_value') || 'Instruction Value'}</FieldLabel>
            <Help type="basic" testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.INSTRUCTION_INPUT)}-help-text`} text={t('ContentTypeFieldProperties.Url.instruction_help_text') || 'Helps you add instructions for this field. The instructional text will appear below the field.'} />
            <Textarea
              name={`${uniqueKey}.instruction`}
              value={schema.field_metadata.instruction || ''}
              onChange={onInstructionChange}
              placeholder={props.t(
                'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
              )}
              version="v2"
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.INSTRUCTION_INPUT)}
              id={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.INSTRUCTION_INPUT)}
            />
          </Field>
          <Field>
            <FieldLabel testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}-label`} className='FieldLabel__CT' htmlFor="helpText" version="v2">{t('ContentTypeFieldProperties.Url.help_text') || 'Help Text'}</FieldLabel>
            <Help type="basic" testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}-help-text`} text={t('ContentTypeFieldProperties.Url.help_text_description') || "Provide additional info about the field. The help text will appear when the user hovers on the '?' sign beside the field name."} />
            <Textarea
              name={`${uniqueKey}.helpText`}
              value={schema.field_metadata.description || ''}
              onChange={onHelpTextChange}
              placeholder={props.t(
                'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
              )}
              version="v2"
              showCharacterCount
              width="full"
              maxLength={256}
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}
              id={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}
            />
          </Field>
        </div>
      </div>
    )
  } else if (type === 'advanced') {
    return (
      <div className="FormFields">
        <Field>
          <FieldLabel testId="cs-form-field-url-validation-regex" version="v2" htmlFor="validation">Validation (Regex)</FieldLabel>
          <Help
            type="basic"
            text={
              props.t(
                'global_field.content_type_edit.body.fields.single_line.settings.advanced.validation_regex.help_text'
              )
                ? props.t(
                  'global_field.content_type_edit.body.fields.single_line.settings.advanced.validation_regex.help_text'
                )
                : 'Define the validation for the field.'
            }
          />
          <TextInput
            name={`${uniqueKey}.validation`}
            version="v2"
            value={schema.format || ''}
            onChange={onValChnage}
            placeholder={props.t(
              'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
            )}
            testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.VALIDATION_REGEX_INPUT)}
          />
        </Field>
        <Field>
          <FieldLabel testId="cs-form-field-url-validation-msg" version="v2" htmlFor="validationErrMsg">Validation Error Message</FieldLabel>
          <Help
            type="basic"
            text={
              props.t(
                'global_field.content_type_edit.body.fields.single_line.settings.advanced.validation_error_message.help_text'
              )
                ? props.t(
                  'global_field.content_type_edit.body.fields.single_line.settings.advanced.validation_error_message.help_text'
                )
                : 'Provide a custom error message to display if the validation checks specified in the Validation (Regex) field fails.'
            }
          />
          <TextInput
            version="v2"
            name={`${uniqueKey}.validationErrMsg`}
            value={schema.error_messages ? (schema.error_messages.format ? schema.error_messages.format : '') : ''}
            onChange={onValErrChange}
            placeholder={props.t(
              'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
            )}
            testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.VALIDATION_ERROR_MESSAGE_INPUT)}
          />
        </Field>
        <Field>
          <FieldLabel className='mb-8' version="v2" testId="cs-form-field-url-options" htmlFor="options">{t('ContentTypeFieldProperties.Url.options') || 'Options'}</FieldLabel>
          <div className="FormFields__selection-wrapper">
            <div className='ToggleWrap'>
              <ToggleSwitch
                testId="cs-ct-field-url-mandatory"
                label={t('ContentTypeFieldProperties.Url.mandatory') || 'Mandatory'}
                name={`${uniqueKey}.mandatory`}
                checked={schema.mandatory || false}
                onChange={onOptionsChange}
                labelPosition="right"
                labelColor="secondary"
              />
            </div>
            {hasNonLocalizablePlan &&
              <>
                <div className='ToggleWrap'>

                  {isNonLocalizable ? (
                    <Tooltip variantType="basic" position="top" content={t('ContentTypeFieldProperties.Url.non_localizable_tooltip') || 'Available only if there are multiple languages in your stack.'}>
                      <ToggleSwitch
                        testId={booleanTestIdFormatter("cs-ct-field-url-non-localizable", schema.non_localizable)}
                        label={t('ContentTypeFieldProperties.Url.non_localizable') || 'Non-localizable'}
                        name={`${uniqueKey}.nonLocalization`}
                        checked={schema.non_localizable}
                        onChange={onOptionsChange}
                        disabled={isNonLocalizable}
                        labelPosition="right"
                        labelColor="secondary"
                      />
                    </Tooltip>
                  ) : (
                    <ToggleSwitch
                      testId={booleanTestIdFormatter("cs-ct-field-url-non-localizable", schema.non_localizable)}
                      label={t('ContentTypeFieldProperties.Url.non_localizable') || 'Non-localizable'}
                      name={`${uniqueKey}.nonLocalization`}
                      checked={schema.non_localizable}
                      onChange={onOptionsChange}
                      disabled={isNonLocalizable}
                      labelPosition="right"
                      labelColor="secondary"
                    />
                    // <Checkbox
                    //   testId="cs-ct-field-url-non-localizable"
                    //   text="Non-localizable"
                    //   name={`${uniqueKey}.nonLocalization`}
                    //   checked={schema.non_localizable}
                    //   onChange={onOptionsChange}
                    //   disabled={isNonLocalizable}
                    // />
                  )}
                </div>

                <div className="nl-note mt-8" data-test-id='cs-ct-field-url-non-localizable-description'>
                  {t('ContentTypeFieldProperties.Url.non_localizable_note') || 'If enabled, editing this field is restricted in localized entries. The field will use the value of the master-language entry in all localized entries.'}
                </div>
              </>
            }
          </div>
        </Field>
        {(urlManagementV2Visible && !options?.singleton) ? (
          <UrlFormattingOptions
            uniqueKey={uniqueKey}
            schema={schema}
            onNotifyChange={onchange}
            disabled={disable}
          />
        ) : null}
      </div>
    )
  }
  return null
}
export default React.memo(Url)
